import OctAuth from '@/components/auth/OctAuth.js'
import OctTags from '@/components/tags/OctTags.js'
import {createProps} from '@/components/user/OctUser.js'
import OctApiAdaptor from '@/components/api-adaptor/OctApiAdaptor.js'
import OctSnackbar from '@/components/snackbar/OctSnackbar.vue';
import OctAccountHeader from '@/components/account-header/OctAccountHeader.vue'
import OctGlobalnav from '@/components/globalnav/OctGlobalnav.vue'
import OctGlobalfooter from '@/components/globalfooter/OctGlobalfooter.vue'
import OctDialog from '@/components/dialog/OctDialog.vue';
import OctDotProgress from '@/components/dot-progress/OctDotProgress.vue';
import OctSvg from '@/components/svg/OctSvg.vue'
import '@/assets/app.scss'

export default {
  mixins: [OctAuth],
  name: 'OctPrototypeView',
  data () {
    return {
      user: createProps(),
      initialized: false,
      invalid: true,
      /** Categories */
      categories: OctTags,
      /** Process status [new | initialized | processing | created ] */
      state: 'new',
      /** Alert title */
      $_octPrototypeView_alertTitle: 'ATTENTION!',
      /** Alert text */
      $_octPrototypeView_alertText: '',
      /** Alert state */
      $_octPrototypeView_isAlertOpen: false,
      /** Alert cancelable */
      $_octPrototypeView_isAlertCancelable: false,
    }
  },
  components: {
    OctGlobalnav,
    OctGlobalfooter,
    OctAccountHeader,
    OctSnackbar,
    OctDialog,
    OctDotProgress,
    OctSvg
  },
  computed: {
    /** Categoris by slug */
    categoriesBySlug () {
      return this.categories.reduce((acc, cur) => {
        acc[cur.slug] = cur
        return acc
      }, {})
    },
    /** Indicate user requires preview */
    requirePreview: () => (new URLSearchParams(location.search)).get('preview') !== null,
    /**
     * Return URL
     * Switch by referrer 
     * /account/your: /account/your/[any]
     * None or Other: /account/dashboard
     */
    $_octPrototypeView_returnURL () {
      let url = '/account/dashboard'

      if (/\/account\/your/.test(document.referrer))
        url = location.pathname.replace('account/', 'account/your#').replace(/\/$/, '') + 's'

      return url
    }
  },
  methods: {
    /** Initialization */
    async initialize () {
      this.initialized = true
    },
    /**
     * Handles the sign-out process for a user.
     * If called with a boolean as the `email` parameter, it will reload the page if the current path is `/account/settings`,
     * otherwise it will redirect to `/account/settings/`.
     * If called with a string or undefined, it will proceed to sign out the user with the provided email.
     *
     * @async
     * @param {string|boolean|undefined} [email=undefined] - The email of the user to sign out, or a boolean flag to trigger reload/redirect logic.
     */
    async onSignout (email=undefined) {
      // Clean up impersonation
      this.deimpersonate()

      if (typeof email === 'boolean') {
        if (/^\/account\/settings/.test(location.pathname))
          location.reload()
        else 
          location.href = '/account/settings/'
      } else
        this.signout(email)
    },
    /** Preview */
    preview (item, path, open=true, callback=undefined) {
      const id = new Date().getTime()
      // Callback function
      if (callback)
        window[`f${id}`] = callback

      // Open new window and post the data
      open && window.open('about:blank', 'marph-preview--' + id)

      // Form to submit
      const form = document.createElement('form')
      if (open)
        form.target = 'marph-preview--' + id
      form.method = 'POST'
      form.action = `${process.env.NODE_ENV === 'development' ? 'http://localhost:8848' : ''}/${path}/preview${callback ? '?callback=f' + id : ''}`

      // The data
      // TODO: データを送信する処理がOxtExhibitionにあるので、データ整形処理を1つにしてこちらでも使いたい
      const previewData = {... item};
      previewData.organizers = [].concat(item.organizers);
      previewData.artists = [].concat(item.artists);
      previewData.data = {... item.data};
      previewData.data.artistsAddedManually = [];
      previewData.data.organizersAddedManually = [];
      const data = document.createElement('input')
      data.type = 'hidden'
      data.name = 'item'
      data.value = JSON.stringify(previewData)

      // The token
      const token = document.createElement('input')
      token.type = 'hidden'
      token.name = 'token'
      token.value = this.token

      form.appendChild(data)
      form.appendChild(token)

      document.body.appendChild(form)

      // Set cookie
      document.cookie = `MARPH_PREVIEW=${this.token};max-age=60;path=/`;

      form.submit()

      document.body.removeChild(form)
    },
    /** Quit handler */
    async onQuit () {
      // Confirm
      if (!confirm('本当に退会しますか？')) return Promise.resolve()

      try {
        // Call remove API and signout
        await OctApiAdaptor.removeUser(this.user.id, this.token)
        this.signout()
      } catch (thrown) {
        alert('退会できませんでした')
        console.log(thrown)
      }
    },
    /** Show snackbar */
    notify (text) {
      this.$refs.$_octSnackbar.open(text)
    },
    /** Normalize tags */
    normalizeTags () {
      if (this.user.tags)
        this.user.tags = this.user.tags.reduce((acc, cur) => {
          // Clean up unused tags
          const tag = this.categoriesBySlug[cur]
          tag && acc.push(cur)

          return acc
        }, [])
    },
    /** Return locale string of specified property */
    getLocaleString (item, property) {
      item = item || this

      const en = item[`${property}EN`]
      const ja = item[property]

      return ja && ja || en
    },
  }
}